module.exports = __webpack_public_path__ + "static/img/card-01.8c6c1b2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-01.jpeg
// module id = QZui
// module chunks = 14